import { createContext } from 'react';

import type { SupportedLocale } from './locales';

export interface LocaleContextValue {
  /** Currently active locale code (BCP-47). */
  locale: SupportedLocale;
  /** Change the locale: updates i18next, persists to localStorage, updates MUI theme. */
  setLocale: (locale: SupportedLocale) => void;
  /** Whether i18next has finished loading the initial namespaces. */
  i18nReady: boolean;
}

// eslint-disable-next-line react-refresh/only-export-components
export const LocaleContext = createContext<LocaleContextValue | null>(null);
